import { Controller, Control } from 'react-hook-form';
import { DecomPolicyFormValues } from '../../decom-policy-form-layout.tsx';
import { timezones } from '../../../../../../utils/timezones.ts';
import VaultTooltipWithLink from './vault-tooltip-with-link.tsx';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface VaultTimezoneSelectProps {
  day: number;
  idx: number;
  control: Control<DecomPolicyFormValues>;
}

export default function VaultTimezoneSelect({
  day,
  idx,
  control,
}: VaultTimezoneSelectProps) {
  return (
    <Controller
      name={`actions.${day}.actions.${idx}.timeZone`}
      control={control}
      render={({ field }) => (
        <FormControl sx={{ minWidth: 350 }} size="small">
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
              Timezone
            </Typography>
            <VaultTooltipWithLink preset="vaultTimezone" sxIcon={{ mb: 0.5 }} />
          </Stack>
          <Select {...field} value={field.value || ''} displayEmpty>
            {timezones.map((tz: string) => (
              <MenuItem key={tz} value={tz}>
                {tz}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}
